<template>
  <div class="container">
    <div class="controls">
      <h2>Personalización del QR</h2>
      
      <label for="urlInput">Enlace / Texto a Codificar</label>
      <input type="text" id="urlInput" v-model="url" placeholder="Escribe el enlace o texto" @input="generateQRCode">
      
      <label for="dotStyle">Estilo de los Puntos</label>
      <select id="dotStyle" v-model="dotStyle" @change="generateQRCode">
        <option value="square">Cuadrado</option>
        <option value="dots">Redondo (Puntos)</option>
        <option value="rounded">Bordes Redondeados</option>
        <option value="extra-rounded">Muy Redondeado</option>
      </select>
      
      <label for="colorInput">Color del QR (Puntos)</label>
      <div class="color-group">
        <input type="color" id="colorInput" v-model="color" @input="generateQRCode">
        <span id="colorValue">{{ color }}</span>
      </div>

      <label for="colorBgInput">Color de Fondo</label>
      <div class="color-group">
        <input type="color" id="colorBgInput" v-model="bgColor" @input="generateQRCode">
        <span id="colorBgValue">{{ bgColor }}</span>
      </div>
      
      <label for="logoSelector">Selecciona Logo Central</label>
      <select id="logoSelector" v-model="logoImage" @change="generateQRCode">
        <option value="">(Sin Logo)</option>
        <option v-for="logo in logoOptions" :key="logo.name" :value="logo.path">
          {{ logo.name }}
        </option>
      </select>
      
      <label for="formatSelector">Formato de Descarga (Resolución: 3000px)</label>
      <select id="formatSelector" v-model="downloadFormat">
        <option value="jpeg">JPEG (Recomendado para color)</option>
        <option value="png">PNG (Recomendado para nitidez)</option>
        <option value="webp">WebP (Formato moderno)</option>
        <option value="svg">SVG (Vectorial - Calidad Ilimitada)</option>
      </select>
      
      <button @click="generateQRCode">Generar / Actualizar QR</button>
      <button id="descargarBtn" @click="downloadQRCode">Descargar QR</button>
    </div>

    <div class="output">
      <h2>Vista Previa</h2>
      <div id="qrcode-preview" ref="qrContainer"></div>
    </div>
  </div>
</template>
  
<script>
// La variable global 'QRCodeStyling' debe cargarse previamente en index.html vía CDN.
/* global QRCodeStyling */ 
  
export default {
  name: 'QrGenerator',
    
  data() {
    return {
      qrCodeInstance: null,
      url: 'https://www.google.com/',
      dotStyle: 'square',
      color: '#3498db',
      bgColor: '#ffffff',
      downloadFormat: 'jpeg',
      logoImage: '',
      
      // NOTA: Estas rutas deben ser accesibles públicamente
      logoOptions: [
        { name: 'Tiendas de Oriente', path: '/logotdo.svg' },
        { name: 'Oasis', path: '/logo.png' },
        { name: 'Quali', path: '/logoquali.png' },
        { name: 'Miniso', path: '/logominiso.png' },
      ],
    };
  },
    
  mounted() {
    if (typeof QRCodeStyling !== 'undefined') {
      this.initializeQRCode();
    } else {
      console.error("Error: QRCodeStyling no está cargado. Asegúrate de incluir el CDN en tu index.html.");
    }
  },
  
  methods: {
    initializeQRCode() {
      this.qrCodeInstance = new QRCodeStyling({
        width: 350, 
        height: 350,
        type: "canvas", 
        data: this.url,
        image: this.logoImage, 
        qrOptions: { errorCorrectionLevel: 'H' },
        dotsOptions: { color: this.color, type: this.dotStyle },
        backgroundOptions: { color: this.bgColor },
        imageOptions: { crossOrigin: "anonymous", margin: 2, hideBackgroundDots: true }
      });
      this.qrCodeInstance.append(this.$refs.qrContainer);
    },
  
    generateQRCode() {
      if (!this.qrCodeInstance) return;
      this.qrCodeInstance.update({
        data: this.url,
        dotsOptions: { color: this.color, type: this.dotStyle },
        backgroundOptions: { color: this.bgColor },
        image: this.logoImage
      });
    },
  
    downloadQRCode() {
      if (!this.qrCodeInstance) return;
      this.qrCodeInstance.update({
        width: 3000, 
        height: 3000 
      });
      this.qrCodeInstance.download({
        name: "codigo_qr_final_HD", 
        extension: this.downloadFormat, 
        quality: 1.0,            
      });
      this.qrCodeInstance.update({
        width: 350, 
        height: 350 
      });
    }
  }
}
</script>
  
<style scoped>
/* Estilos base (aplican a móvil y escritorio) */
.container {
    display: flex;
    gap: 30px;
    width: 100%;
    max-width: 1000px;
    background: #fff;
    padding: 30px;
    border-radius: 10px;
    margin-top: 35px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.controls {
    flex: 1;
    padding: 10px;
    border-right: 1px solid #eee; /* Separador vertical en escritorio */
}
.output {
    flex: 1;
    text-align: center;
    padding: 10px;
}
label {
    display: block;
    margin-top: 15px;
    margin-bottom: 5px;
    font-weight: bold;
    color: #2c3e50;
    font-size: 14px;
}
input[type="text"], input[type="color"], select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    margin-bottom: 10px;
}
input[type="color"] {
    width: 50px;
    height: 35px;
    padding: 0;
}
.color-group, .style-group {
    display: flex;
    align-items: center;
    gap: 10px;
}
button {
    background-color: #2ecc71;
    color: white;
    border: none;
    padding: 10px 20px;
    margin-top: 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    width: 100%;
    transition: background-color 0.3s ease;
}
button:hover {
    background-color: #27ae60;
}
#descargarBtn {
    background-color: #3498db;
    margin-top: 10px;
}
#descargarBtn:hover {
    background-color: #2980b9;
}
#qrcode-preview {
    margin: 20px auto;
    width: 300px; 
    height: 300px;
}
#qrcode-preview canvas {
    width: 100%;
    height: 100%;
}

/* MEDIA QUERY para Responsive Design */
@media (max-width: 768px) {
    .container {
        flex-direction: column; /* Apila los controles y la vista previa */
        padding: 20px;
        margin-top: 0;
        gap: 0;
    }

    .controls {
        border-right: none; 
        border-bottom: 1px solid #eee; /* Separador horizontal en móvil */
        margin-bottom: 20px;
        padding-bottom: 20px;
    }

    .output {
        padding-top: 0;
        padding-bottom: 10px;
    }
    
    /* El contenedor del QR puede ser un poco más pequeño en pantallas muy pequeñas */
    #qrcode-preview {
        width: 250px; 
        height: 250px;
        margin: 10px auto;
    }
}
</style>